function NavLogo() {
  return (
    <a className='flex-shrink-0 mr-12 text-2xl text-white' href='/'>
      <p>RM Workspace</p>
    </a>
  );
}

export default NavLogo;
